import { __extends } from "tslib";
import React from 'react';
import { translationUtils } from '@wix/photography-client-lib';
import { utils } from '../utils';
import style from './galleryEmpty.scss';
var GalleryEmpty = /** @class */ (function (_super) {
    __extends(GalleryEmpty, _super);
    function GalleryEmpty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalleryEmpty.prototype.render = function () {
        if (utils.isVerbose()) {
            console.log('Not rendering - gallery is empty');
        }
        var emptyContent = utils.isStoreGallery() ? (React.createElement("div", null,
            React.createElement("div", { className: style['pro-gallery-empty-title'] },
                translationUtils.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header'),
                React.createElement("br", null),
                translationUtils.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header2')),
            React.createElement("div", { className: style['pro-gallery-empty-info'] },
                translationUtils.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Text'),
                React.createElement("br", null)))) : (React.createElement("div", null,
            React.createElement("div", { className: style['pro-gallery-empty-title'] },
                translationUtils.getByKey('Gallery_Empty_Title'),
                React.createElement("br", null),
                translationUtils.getByKey('Gallery_Empty_Title2')),
            React.createElement("div", { className: style['pro-gallery-empty-info'] },
                translationUtils.getByKey('Gallery_Empty_Description'),
                React.createElement("br", null),
                translationUtils.getByKey('Gallery_Empty_Description2'))));
        return (React.createElement("div", { className: style['pro-gallery-empty'] },
            React.createElement("div", { className: style['pro-gallery-empty-wrapper'] },
                React.createElement("div", { className: style['pro-gallery-empty-image'] }),
                emptyContent)));
    };
    return GalleryEmpty;
}(React.Component));
export default GalleryEmpty;
//# sourceMappingURL=galleryEmpty.js.map